import React from 'react';
import styles from './options.scss';

import {
    singleSelectInputOptionPropTypes,
    singleSelectInputOptionDefaultProps,
} from './propTypes';

import {
    getOptionClassName,
} from './utils';

export default class Options extends React.PureComponent {
    static propTypes = singleSelectInputOptionPropTypes;
    static defaultProps = singleSelectInputOptionDefaultProps;

    handleClick = () => {
        const {
            optionKey,
            onClick,
        } = this.props;

        onClick(optionKey);
    }

    render() {
        const {
            optionLabel,
            active,
        } = this.props;

        return (
            <button
                className={getOptionClassName(styles, active)}
                onClick={this.handleClick}
            >
                { optionLabel }
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/public/components/Input/SelectInput/Option.js